// extracted by mini-css-extract-plugin
export default {"texto":"ModalDoCodigo_texto__0Uz22","feito":"ModalDoCodigo_feito__BqhHc"};